import { createColumnHelper } from "@tanstack/react-table";

import { Patient } from "~/common/utils";
import { PatientEngagementTag } from "~/providers/components/patientSearch/PatientEngagementTag";
import {
  formatConsultationRequestRowData,
  getConsultationStatusText,
  getFullName,
  getPatientEngagement,
} from "~/providers/utils";
import { PATIENT_SEARCH_TABLE_COLUMN_IDS } from "./patientSearchTableSorting";

const columnHelper = createColumnHelper<Patient>();

export const patientSearchTableColumns = [
  columnHelper.accessor((row) => getFullName(row.name, row.last_name), {
    id: PATIENT_SEARCH_TABLE_COLUMN_IDS.name,
    header: "Name",
    cell: ({ row }) => {
      const { name, last_name: lastName } = row.original;

      return (
        <div className="flex items-center gap-4 capitalize">
          {getFullName(name, lastName)}
        </div>
      );
    },
  }),
  columnHelper.accessor(
    (row) => {
      const isTerminated = !!row.consultation?.terminated_at;

      return getConsultationStatusText(isTerminated, row.consultation?.status);
    },
    {
      id: PATIENT_SEARCH_TABLE_COLUMN_IDS.consultationStatus,
      header: "Consultation status",
      cell: ({ row }) => {
        const isTerminated = !!row.original.consultation?.terminated_at;

        return (
          <span className="inline-block first-letter:uppercase">
            {getConsultationStatusText(
              isTerminated,
              row.original.consultation?.status,
            )}
          </span>
        );
      },
    },
  ),
  columnHelper.accessor(
    (row) =>
      getFullName(
        row.organization_patients?.[0]?.primary_provider?.name,
        row.organization_patients?.[0]?.primary_provider?.last_name,
      ) || "-",
    {
      id: PATIENT_SEARCH_TABLE_COLUMN_IDS.primaryProvider,
      header: "Primary provider",
      cell: ({ row }) => {
        const providerName = getFullName(
          row.original.organization_patients?.[0]?.primary_provider?.name,
          row.original.organization_patients?.[0]?.primary_provider?.last_name,
        );

        return (
          <span className="inline-block first-letter:uppercase">
            {providerName || "-"}
          </span>
        );
      },
    },
  ),
  columnHelper.accessor((row) => formatConsultationRequestRowData(row).state, {
    id: PATIENT_SEARCH_TABLE_COLUMN_IDS.state,
    header: "State",
    cell: ({ row }) => formatConsultationRequestRowData(row.original).state,
  }),
  columnHelper.accessor((row) => getPatientEngagement(row), {
    id: PATIENT_SEARCH_TABLE_COLUMN_IDS.engagement,
    header: "Engagement",
    cell: ({ row }) => (
      <PatientEngagementTag engagement={getPatientEngagement(row.original)} />
    ),
  }),
];
